<script lang="ts">
	import { ItineraryConstraint } from '$houdini';
	import Select from '$lib/components/atoms/select/Select.svelte';
	import SkeletonInput from '$lib/components/atoms/skeleton/SkeletonInput.svelte';
	import { getTripConstraintOptions } from '$lib/components/itinerary/tripOptions';
	import { getMapLayoutContext } from '$lib/components/map/map-layout-context';
	import * as m from '$paraglide/messages';

	const { tripOptionsStore } = getMapLayoutContext();

	interface Props {
		loading?: boolean;
	}

	const { loading = false }: Props = $props();
</script>

{#if loading}
	<SkeletonInput label={m.itinerary__options__trip_constraint()} />
{:else}
	<Select
		label={m.itinerary__options__trip_constraint()}
		options={getTripConstraintOptions()}
		defaultValue={$tripOptionsStore.tripConstraint}
		ariaLabel={m.itinerary__options__trip_constraint()}
		dropDownSameWidth
		onSelectedChange={constraint =>
		($tripOptionsStore.tripConstraint = constraint ?? ItineraryConstraint.NONE)}
	/>
{/if}
